import { updateAdminCatalogSystem, updateAdminGroupContent } from '../api';
import type { ProductGroup } from '../types';
import { resolveAdminGroupContentSaveId } from './productGroupCopy';
import { isRazdvizhnyeBranch } from './razdvizhnyeTier';

export type AdminMarketingCopyPatch = {
  short_description?: string;
  full_description?: string;
  advantages?: string[];
};

/** Сохранение текстов карточки: в привязанную catalog_system (как медиа), иначе by-group + tier. */
export async function persistAdminProductGroupCopy(args: {
  adminSystemId: number | null;
  group: ProductGroup;
  effectiveGroupId: string | null;
  catalogTier: string | null;
  patch: AdminMarketingCopyPatch;
}): Promise<void> {
  const { adminSystemId, group, effectiveGroupId, catalogTier, patch } = args;
  const tierSlug =
    catalogTier && isRazdvizhnyeBranch(group) ? catalogTier : undefined;
  const routeId = String(effectiveGroupId || group.group_id || '').trim();
  if (!routeId && !adminSystemId) {
    throw new Error('Нет привязки к карточке каталога для сохранения текста');
  }

  if (adminSystemId && adminSystemId > 0) {
    const sysPayload: {
      short_description?: string;
      full_description?: string;
      advantages?: string[];
    } = {};
    if (patch.short_description !== undefined) {
      sysPayload.short_description = patch.short_description;
    }
    if (patch.full_description !== undefined) {
      sysPayload.full_description = patch.full_description;
    }
    if (patch.advantages !== undefined) {
      sysPayload.advantages = patch.advantages;
    }
    if (Object.keys(sysPayload).length > 0) {
      await updateAdminCatalogSystem(adminSystemId, sysPayload);
    }
    return;
  }

  const saveGroupId = resolveAdminGroupContentSaveId(group, routeId);
  await updateAdminGroupContent({
    group_id: saveGroupId,
    ...patch,
    ...(tierSlug ? { tier_slug: tierSlug } : {}),
  });
}
